// extracted by mini-css-extract-plugin
export default {"underwritersScoreContainer":"nbitelematics_underwritersScoreContainer__xxToW","nbiTelematicsContainer__Score":"nbitelematics_nbiTelematicsContainer__Score__rxtCK"};